import React from 'react'
import PostFooter from '../Components/PostFooter'
import Middle from '../Components/PostMiddle'
// import PostNavbar from '../Components/PostNavbar'

const PostJob = () => {
  return (
    <>
        {/* <PostNavbar /> */}
        <Middle />
        <PostFooter />
    </>
  )
}

export default PostJob